"use client"
import { cn } from "@abraxas/ui/lib"
import * as Collapsible from "@radix-ui/react-collapsible"
import { ChevronDown } from "lucide-react"
import ReactMarkdown from "react-markdown"

import { useState } from "react"

const components = {
  a(props) {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:no-underline"
        {...props}
      />
    )
  },
}

export function SingleFAQ({ faq }: { faq: any }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Collapsible.Root open={isOpen} onOpenChange={setIsOpen} className="pb-4">
      <Collapsible.Trigger className="w-full pt-4 text-[18px]">
        <div
          className={cn(
            "flex items-center justify-between",
            "transition-colors hover:text-yellow",
            isOpen && "text-yellow",
          )}
        >
          <div className="font-semibold">{faq.title}</div>
          <ChevronDown
            className={cn("transition-all duration-200", {
              "rotate-180": isOpen,
            })}
          />
        </div>
      </Collapsible.Trigger>
      <Collapsible.Content
        className={cn(
          "overflow-hidden",
          "data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down",
        )}
      >
        <div className="prose mt-2">
          <ReactMarkdown components={components}>{faq.body}</ReactMarkdown>
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  )
}
